export function fmtMoney(amount, currency = "KMF") {
  const n = Number(amount || 0);
  return `${n.toLocaleString("fr-FR")} ${currency}`;
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function fmtDay(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export const STATUS_FLOW = ["Reçu", "Lavage", "Séchage", "Repassage", "Prêt", "Livré"];

export const STATUS_COLORS = {
  "Reçu": "bg-slate-100 text-slate-700",
  "Lavage": "bg-blue-100 text-blue-700",
  "Séchage": "bg-amber-100 text-amber-700",
  "Repassage": "bg-purple-100 text-purple-700",
  "Prêt": "bg-emerald-100 text-emerald-700",
  "Livré": "bg-teal-100 text-teal-700",
};

export const PAY_COLORS = {
  "Payé": "bg-emerald-100 text-emerald-700",
  "Partiel": "bg-amber-100 text-amber-700",
  "Non payé": "bg-red-100 text-red-700",
};
